<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

<div v-if="data_student.length > 0">
 


 

<div class="columns is-gapless">
    <div class="column is-1 has-text-centered">
        <button @click="delete_student_confirm()" class="button is-fullwidth has-text-weight-bold has-background-danger has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>
    <div class="column is-6 has-text-centered"></div>

    <div class="column is-1 has-text-centered">
        <button @click="print_bulletin()" class="button is-fullwidth has-text-weight-bold has-background-info-light has-text-info-dark" style="">
            <span class="icon has-text-left"><i class="fas fa-print"></i></span>     
        </button>
    </div>


    <div class="column is-4 has-text-centered">
        <button @click="student_update()" class="button is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>
</div>


<div class="columns is-multiline box is-shadowless" style="padding-top:1em;">



<div class="column is-2 isLink" onclick="document.getElementById('selectFile').click();">
    <input id="selectFile" type="file" style="display: none;" @change="item_image" accept="image/*">
    <figure class="image is-128x128"> <img :src="return_pic(data_student[0].student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="...."></figure>
</div>



 

<!-- NAME / ADDRESS  -->
<div class="column is-6">
<div class="columns is-gapless is-mobile is-multiline" style="margin-left:.4em;">

    <div class="column is-6 isLabel">Nom</div>
    <div class="column is-6 isLabel">Prenom</div>

    <div class="column is-6">
        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_lNAME" class="input is-dark is-uppercase is-size-4 is-fullwidth has-text-weight-bold" placeholder="Nom ">
    </div>

    <div class="column is-6">
        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_fNAME" class="input is-dark is-uppercase is-size-4 is-fullwidth has-text-weight-bold" placeholder="Nom ">
    </div>

 
<!-- ADDRESS !!!!  -->
<div class="column is-12" style="margin-top:.5em;">
<div v-if="enabled" class="columns is-gapless" style="margin-top:-.3em;margin-bottom:-0em;">

    <div class="column is-10">
    <div class="control has-icons-left has-icons-right">
    <span class="icon is-left"><i class="fas fa-map-marker-alt fa-lg"></i></span>
        <vue-google-autocomplete
            :disabled="!enabled" 
            ref="Address"
            id="map"
            classname="input is-dark is-fullwidth has-text-weight-bold"
            placeholder="nouvelle adresse"
            v-on:placechanged="getAddressData"
            v-model="address_string"
            country="ca">
        </vue-google-autocomplete> 
    </div></div> 
    <div class="column is-2">  
        <input @change="something_changed()" v-model="data_student[0].student_apt" class="input is-dark is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Apt. ">
    </div>

</div>

<!-- <div class="columns is-gapless" style="margin-top:0em;">
    <div class="column is-12 is-size-5 has-text-weight-bold has-text-grey">{{ return_address() }} </div>
</div> -->

</div>
<!-- END ADDRESS !!!!  -->



</div></div> 
<!-- END NAME / ADDRESS  -->



<div class="column is-4">
<div class="columns is-gapless is-mobile is-multiline" style="margin-left:.4em;">

    <div class="column is-12 isLabel">Code Permanent</div>

    <div class="column is-12">
        <input v-mask="'AAAA########'" :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_CodePerm" class="input is-uppercase is-fullwidth has-text-weight-bold has-text-centered is-info" placeholder="Code Permanent ">
    </div>

    <div class="column is-12 isLabel" style="margin-top:.5em;">Groupe Code</div>
    <div class="column is-12">
        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_GRPCODE" class="input is-fullwidth has-text-weight-bold has-text-centered has-background-warning" placeholder="Group Code ">
    </div>






</div></div> 
<!-- CODES / bDAY  v-if="data_student.length > 0"-->


<div class="column is-12">
<!-- PHONE(s) / EMAIL  -->
<div class="columns is-centered is-gapless is-mobile is-multiline" style="">

    <div class="column is-1 isLabel"></div>
    <div class="column is-3 isLabel has-text-centered">Tel. Cell</div>
    <div class="column is-3 isLabel has-text-centered">Tel. Autre</div>
    <div class="column is-5 isLabel has-text-centered">Email</div>
    <!-- <div class="column is-2 isLabel"></div> -->

    <div class="column is-1"></div>
    <div class="column is-3">
        <input v-mask="'(###) ###-####'" :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_TelOther" class="input is-fullwidth has-text-weight-bold has-text-centered is-size-5" placeholder="Cellulaire ">
    </div>

    <div class="column is-3">
        <input v-mask="'(###) ###-####'" :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_TelHome" class="input is-fullwidth has-text-weight-bold has-text-centered is-size-5" placeholder="Autre ">
    </div>

    <div class="column is-5" style="">
    <div class="control has-icons-left has-icons-right">
    <span class="icon is-left"><i class="fas fa-envelope fa-lg"></i></span>

        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_eMail" class="input is-fullwidth has-text-weight-bold is-size-5" placeholder="Email ">
    </div></div>
    <div class="column is-2"></div>
</div></div>
<!-- END NAME / ADDRESS  -->
</div>
<!-- END DETAILS  -->













<!-- <div class="columns is-gapless" style="margin-top:-.5em;margin-bottom:.5em;">
    <div class="column is-3 has-text-centered has-text-dark has-text-weight-bold">
    <div class="columns is-multiline is-gapless">
    <div  @click="student_change_view('NOTES')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-list-ol"></i></span>NOT</div>
    <div  @click="student_change_view('PAIMENTS')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-info-circle"></i></span>PAI</div>
    </div>
    </div>    
</div> -->


<!-- STUDENT NOTES !!!! -->
<div class="columns is-centered">
    <div class="column is-12 box">
        <CompComments :student_id="studentID"> </CompComments>   
    </div>
</div>


<!-- STUDENT PAYENTS !!!!
<div v-if="view_student == 'PAIMENTS'" class="box has-background-light" style="">
    <PaymentsStudent :studentID="studentID" :key="studentID" ></PaymentsStudent>
</div> -->



</div></div>
</template>

<script>
import axios from 'axios';
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import moment from 'moment';

import CompComments from "@/components/Comp_Student_Comments"
import PaymentsStudent  from '@/components/Comp_Student_Payments';

import jsBulletin from "@/assets/js/js_bulletin.js";

export default {

    props: [ 'studentID', 'enabled' ],
    components: { VueGoogleAutocomplete, CompComments, PaymentsStudent },

    data() {
        return {
isLoading:true,
isReady : false , // AFTER LOAD !
isDirty : false, // FOR DETECTING CHANGES


            show_save:false,
            data_student:[],
            

view_student : 'NOTES',


config: { // FLATPICKER
    altFormat: "M j, Y",
    altInput: true
},

address_string: '',

            address: '',
            place: '',
        }
    },               

watch: { // CHECK FOR CHANGE !!
    data_student: {
        handler: function() {
           if (this.isReady) {this.$emit("emit_somethingChanged")}
        },
        deep: true
    }
},



created() {


if (this.studentID) {
    this.isLoading=true;
    var sql = "SELECT * FROM myMEQ_STUDENT WHERE student_ID = " + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.isLoading=false;    
        this.data_student = res.data
        setTimeout(() => { this.isReady=true; }, 500); // !
        this.address_string = this.return_address()
        // VIEW
        if (sessionStorage.getItem('view_student')) { this.view_student = sessionStorage.getItem('view_student') }
       })  
}

}, // END CREATED

methods: {

delete_student_confirm:function() {

        this.$snotify.confirm('Delete Student? ' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
        position: "leftTop", 
            buttons: [
                {text: 'Yes', action: (toast) => this.delete_student_do(toast)},
                {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
            ]
        });
},
delete_student_do:function(toast) {
    this.$snotify.remove(toast.id)

var query = "DELETE FROM myMEQ_STUDENT WHERE student_ID = " + this.studentID 
query += "; DELETE FROM MyMEQ_COURSESTUDENT WHERE student_ID = " + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.$emit("emit_student_deleted")
        this.$snotify.success('Deleted !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true});
    });


},


// SAVE WHERE WE ARE ....
student_change_view(view) {
    this.view_student = view
    sessionStorage.setItem('view_student', view)
},

emit_save:function() {
// CALLED FROM PARENT (STUDENT)
    this.student_update()
    // SEND BACK NAME (+) FOR DISPLAY  
    
},




chk_string:function(val){
    // CHECK FOR BLANC STRING --
    try {return val.replace(/'/g,"''")}
    catch(err) {return ''}
},
chk_date:function(val){
    // CHECK FOR BLANC STRING --
    if (val != null) 
    {return "'" + moment(val).format('YYYY-MM-DD') + "'"}
    else {return null}
},

return_address:function() {
    var address = ''
    if (this.data_student[0].student_apt) {address += '#' + this.data_student[0].student_apt + "-"}
    address += this.data_student[0].student_rueNUM + ' ' + this.data_student[0].student_Address
    address += ', ' + this.data_student[0].student_City + ' ' + this.data_student[0].student_Postal
    return address.replace(/null/g,"")
},


student_update:function() {
  //  this.isLoading=true;

var sql;

// ADDRESS 
var sqlAddress = ''
if (this.address) {

    sqlAddress += ", student_rueNUM = '" + this.chk_string(this.address.street_number) + "'," ; this.data_student[0].student_rueNUM = this.address.street_number
    sqlAddress += "student_Address = '" + this.chk_string(this.address.route) + "'," ; this.data_student[0].student_Address = this.address.route 
    sqlAddress += "student_City = '" + this.chk_string(this.address.locality) + "'," ; this.data_student[0].student_City = this.address.locality
    sqlAddress += "student_Province = '" + this.chk_string(this.address.administrative_area_level_1) + "'," ; this.data_student[0].student_Province = this.address.administrative_area_level_1
    sqlAddress += "student_Country = '" + this.chk_string(this.address.country) + "'," ; this.data_student[0].student_Country = this.address.country
    sqlAddress += "student_Postal = '" + this.chk_string(this.address.postal_code) + "' " ; this.data_student[0].student_Postal = this.address.postal_code

}

    sql = "UPDATE MyMEQ_STUDENT SET "
    sql += "student_fNAME = '" + this.chk_string(this.data_student[0].student_fNAME) + "',"
    sql += "student_lNAME = '" + this.chk_string(this.data_student[0].student_lNAME) + "',"
    sql += "student_TelOther = '" + this.chk_string(this.data_student[0].student_TelOther) + "',"
    sql += "student_TelHome = '" + this.chk_string(this.data_student[0].student_TelHome) + "',"
    sql += "student_eMail = '" + this.chk_string(this.data_student[0].student_eMail) + "', "
    sql += "student_CodePerm = '" + this.chk_string(this.data_student[0].student_CodePerm) + "', "
    sql += "student_GRPCODE = '" + this.chk_string(this.data_student[0].student_GRPCODE) + "', "
    
    sql += "student_apt = '" + this.chk_string(this.data_student[0].student_apt) + "'  "



    sql += sqlAddress
    sql += " WHERE student_ID = " + this.studentID

console.log(sql)

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
    this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true});
    this.$emit('emit_data_update', this.data_student[0])
    this.$emit("emit_somethingSaved")
    this.isLoading=false;   })  

}, // ENDUPDATE


    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData) {
        this.address = addressData;
        this.address_string = addressData
        this.place = placeResultData
    },



return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},

item_image:function(event) {
  this.imageChanged = true;
  this.$emit('mod_emit');
  var input = event.target;
  if (input.files && input.files[0]) { 

console.log(input.files[0].name)

const formData = new FormData();
let file = input.files[0];
formData.append('files', file);
axios.post(this.$url+'/upload_image',formData) 
.then(res => {
    var sql = "UPDATE myMEQ_STUDENT SET student_PhotoPath = '" + input.files[0].name
    sql += "' WHERE student_ID = " + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.stud_photo = input.files[0].name
        this.data_student[0].student_PhotoPath = input.files[0].name
        this.$emit('emit_photo_change', input.files[0].name)
    })
})
}

},


print_bulletin:function(){

    var sql;
    var courses_that = []
    var courses_this = []

    var data_program = []



// GET PROGRAM DATA -- IF NONE THEN GET OUT!
sql = `SELECT MyMEQ_PROGRAM.* 
FROM MyMEQ_STUDENT INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID WHERE student_ID = ` + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => {
        if (!res.data) {alert ('No Program!') ; return}
            data_program = res.data

console.log(data_program)

    // GET DATA
    sql="SELECT  * FROM  MyMEQ_STUDENT_OTHERSCHOOL WHERE student_ID = " +  this.studentID + " ORDER BY other_Session, other_Annee"
console.log(sql)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
    courses_that = res.data
     
    sql="SELECT  MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_COURSESTUDENT.cs_TotalAbs,  MyMEQ_GROUP.group_SESS, MyMEQ_GROUP.group_ANN, MyMEQ_GROUP.group_AVG, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F,  MyMEQ_COUR.cour_TITRE_E,cour_UNITS FROM  MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN  MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID WHERE student_ID = " +  this.studentID + " ORDER BY group_SESS, group_ANN"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
    courses_this = res.data
    console.log(res.data)

var bullData = jsBulletin.bulletin_create(this.data_student[0],courses_this,courses_that, data_program)
 
console.log(bullData)

        axios.get(this.$url+'/create_bulletin?file=' + this.data_student[0].student_CodePerm+'&data='+encodeURIComponent(bullData))
        .then(res => {
            window.open(this.$url+'/download?file=' + this.data_student[0].student_CodePerm);
        }) 

    }) // END THEN THIS
    }) // END THEN THAT
    }) // END PROGRAM
},



}, // END METHODS


} // END EXPORT

</script>


<style scoped>

input{padding:5px; border:2px solid #ccc; 
-webkit-border-radius: 5px;
    border-radius: 5px;
}
input:focus {border-color:#333; }

</style>